/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Section_BlurbInputs */



/**
* | output |
* | --- |
* | "Found a bug or have an idea? Let us know and we'll look into it." |
*
* @param {Feedback_Section_BlurbInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const feedback_section_blurb = /** @type {((inputs?: Feedback_Section_BlurbInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Section_BlurbInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous avez trouvé un bug ou une idée ? Faites-le nous savoir, nous y jetterons un œil.")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Ha encontrado un error o tiene una idea? Comuníquenoslo y lo estudiaremos.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Encontrou um bug ou tem uma ideia? Nos conte e vamos analisar.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Hai trovato un bug o hai un'idea? Faccelo sapere e lo esamineremo.")
	return /** @type {LocalizedString} */ ("Found a bug or have an idea? Let us know and we'll look into it.")
});